export const loginModes = {
	legacy: 'legacy',
	oktaless: 'oktaless',
	oktaonly: 'oktaonly',
};

export const isLoginMode = (value) => Object.values(loginModes).includes(value);

export const isBypassMode = (value) => value === loginModes.oktaless;

export const resolveLoginMode = ({ modeParam, oktaOnlyLoginEnabled }) => {
	if (isLoginMode(modeParam)) return modeParam;
	return oktaOnlyLoginEnabled ? loginModes.oktaonly : loginModes.legacy;
};
